import { ISelectInputProps, SelectInput } from '@framework/form';
import { ButtonProps } from 'antd';
import * as React from 'react';
import { useAsyncServicesOptions } from './useAsyncServicesOptions';

export interface IAsyncServiceSelectInputProps extends ISelectInputProps {
  name: string;
  size?: ButtonProps['size'];
  style?: React.CSSProperties;
}

/**
 * Seleziona l'ID di un servizio asincrono.
 */
export function AsyncServiceSelectInput(props: IAsyncServiceSelectInputProps) {
  const options = useAsyncServicesOptions();
  const { name, size } = props;
  return (
    <SelectInput
      {...props}
      size={size}
      options={options}
      name={name}
      showSearch
      style={{ minWidth: '100px', ...props.style }}
      dropdownMatchSelectWidth={false}
      optionFilterProp="label"
    />
  );
}
